import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFilteredPlanReviewsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Plan_Reviews_Bool_Exp>;
}>;


export type GetFilteredPlanReviewsQuery = { __typename?: 'query_root', plan_reviews: Array<{ __typename?: 'plan_reviews', id: any, ollie_id: string, property_id: any, organization_id?: any | null, jurisdiction_id?: any | null, review_type: string, created_at: any, updated_at: any, property: { __typename?: 'properties', id: any, name: string, address?: string | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string } | null }, organization?: { __typename?: 'organizations', id: any, name: string } | null, jurisdiction_record?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string } | null, submission_type?: { __typename?: 'plan_review_submission_types', id: any, code: string, name: string, short_name?: string | null } | null, plan_review_jobs_aggregate: { __typename?: 'plan_review_jobs_aggregate', aggregate?: { __typename?: 'plan_review_jobs_aggregate_fields', count: number } | null }, plan_review_jobs: Array<{ __typename?: 'plan_review_jobs', id: any, state: string, review_outcome?: string | null, compliance_score?: number | null, submission_number: number, created_at: any, updated_at: any, plan_review_findings_aggregate: { __typename?: 'plan_review_findings_aggregate', aggregate?: { __typename?: 'plan_review_findings_aggregate_fields', count: number } | null } }> }> };


export const GetFilteredPlanReviewsDocument = gql`
    query getFilteredPlanReviews($where: plan_reviews_bool_exp) {
  plan_reviews(where: $where, order_by: {created_at: desc}) {
    id
    ollie_id
    property_id
    property {
      id
      name
      address
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
      }
      photo_link
    }
    organization_id
    organization {
      id
      name
    }
    jurisdiction_id
    jurisdiction_record {
      id
      name
      short_name
    }
    review_type
    submission_type {
      id
      code
      name
      short_name
    }
    created_at
    updated_at
    plan_review_jobs_aggregate {
      aggregate {
        count
      }
    }
    plan_review_jobs(order_by: {submission_number: desc}, limit: 1) {
      id
      state
      review_outcome
      compliance_score
      submission_number
      created_at
      updated_at
      plan_review_findings_aggregate(
        where: {status: {_in: ["FAIL", "MISSING", "WARNING"]}}
      ) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetFilteredPlanReviewsQuery__
 *
 * To run a query within a React component, call `useGetFilteredPlanReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredPlanReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredPlanReviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFilteredPlanReviewsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredPlanReviewsQuery, GetFilteredPlanReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredPlanReviewsQuery, GetFilteredPlanReviewsQueryVariables>(GetFilteredPlanReviewsDocument, options);
      }
export function useGetFilteredPlanReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredPlanReviewsQuery, GetFilteredPlanReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredPlanReviewsQuery, GetFilteredPlanReviewsQueryVariables>(GetFilteredPlanReviewsDocument, options);
        }
export function useGetFilteredPlanReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredPlanReviewsQuery, GetFilteredPlanReviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredPlanReviewsQuery, GetFilteredPlanReviewsQueryVariables>(GetFilteredPlanReviewsDocument, options);
        }
export type GetFilteredPlanReviewsQueryHookResult = ReturnType<typeof useGetFilteredPlanReviewsQuery>;
export type GetFilteredPlanReviewsLazyQueryHookResult = ReturnType<typeof useGetFilteredPlanReviewsLazyQuery>;
export type GetFilteredPlanReviewsSuspenseQueryHookResult = ReturnType<typeof useGetFilteredPlanReviewsSuspenseQuery>;
export type GetFilteredPlanReviewsQueryResult = Apollo.QueryResult<GetFilteredPlanReviewsQuery, GetFilteredPlanReviewsQueryVariables>;